import React from 'react';
import { OperationListMainWrapper } from './OperationListView.styles';
import OperationListContent from './OperationListContent';

const OperationListContainer: React.FC = () => {
    return (
        <OperationListMainWrapper>
            <OperationListContent />
        </OperationListMainWrapper>
    );
};

export default OperationListContainer;
